export default "__VITE_ASSET__DF5Yq_Go__"